export const subscriptionActionTypes = {

    /*
     * Subscription subscribe constants
     */
    SUBSCRIBE_REQUEST: 'SUBSCRIPTIONS_SUBSCRIBE_REQUEST',
    SUBSCRIBE_SUCCESS: 'SUBSCRIPTIONS_SUBSCRIBE_SUCCESS',
    SUBSCRIBE_FAILURE: 'SUBSCRIPTIONS_SUBSCRIBE_FAILURE',
    
    /*
     * User subscription fetch
     */
    GET_SUBSCRIPTION_REQUEST: 'SUBSCRIPTIONS_GET_SUBSCRIPTION_REQUEST',
    GET_SUBSCRIPTION_SUCCESS: 'SUBSCRIPTIONS_GET_SUBSCRIPTION_SUCCESS',
    GET_SUBSCRIPTION_FAILURE: 'SUBSCRIPTIONS_GET_SUBSCRIPTION_FAILURE',

};